"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapVerifySignatureKeyToChallenge = void 0;
const challengeUtils_1 = require("../../../../../security/authoriser/utils/challengeUtils");
const mapVerifySignatureKeyToChallenge = (verifySignatureKeyResponse) => (0, challengeUtils_1.mapToChallenge)(verifySignatureKeyResponse);
exports.mapVerifySignatureKeyToChallenge = mapVerifySignatureKeyToChallenge;
//# sourceMappingURL=mapper.js.map